module.exports = __webpack_public_path__ + "static/media/sell_cancel_5.f6d714cb.jpg";